import { render, staticRenderFns } from "./BrandWelcome.vue?vue&type=template&id=5add952c&scoped=true&"
import script from "./BrandWelcome.vue?vue&type=script&lang=js&"
export * from "./BrandWelcome.vue?vue&type=script&lang=js&"
import style0 from "./BrandWelcome.vue?vue&type=style&index=0&id=5add952c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5add952c",
  null
  
)

export default component.exports